var _style, _defs, _path, _path2, _rect, _path3, _path4, _rect2, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstacionamiento(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 266 232",
    style: {
      enableBackground: "new 0 0 266 232"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000111181419628725894460000017658509274678628738_);}\n\t.st1{fill:#FB8B44;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 90.08,
    y: 81.35,
    width: 85.84,
    height: 69.29
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000007398733731464916910000013180336079500030140_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1153",
    style: {
      clipPath: "url(#SVGID_00000007398733731464916910000013180336079500030140_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2045",
    className: "st1",
    d: "M174.79,141.09H91.21c-0.63-0.03-1.13-0.54-1.13-1.18v-28.69c0-0.63,0.5-1.15,1.13-1.18 h0.93l8.65-7.97c0.2-0.19,0.47-0.29,0.74-0.29h63.89c0.3,0,0.58,0.13,0.79,0.34l7.71,7.93h0.88c0.63,0.03,1.13,0.54,1.13,1.18 v28.68C175.92,140.54,175.42,141.06,174.79,141.09 M92.34,138.7h81.33v-26.28h-0.21c-0.3,0-0.58-0.12-0.79-0.34l-7.71-7.93h-63 l-8.65,7.98c-0.2,0.19-0.47,0.29-0.74,0.29h-0.23V138.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2046",
    className: "st1",
    d: "M164.66,102.86h-63.29c-0.4-0.01-0.77-0.23-0.96-0.59c-0.21-0.36-0.23-0.8-0.05-1.18 l8.87-19.08c0.18-0.4,0.58-0.66,1.02-0.66h44.01c0.41,0,0.78,0.23,0.98,0.59l10.41,19.12c0.2,0.37,0.2,0.81,0,1.18 c-0.19,0.36-0.57,0.59-0.98,0.59 M103.18,100.47h59.53l-9.11-16.73h-42.65L103.18,100.47z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_491",
    x: 119.44,
    y: 119.58,
    className: "st1",
    width: 29.36,
    height: 2.39
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2047",
    className: "st1",
    d: "M114.28,121.98H91.79l-0.18-0.95c-1-3.42-0.45-7.11,1.49-10.11c1.64-2,4.07-3.2,6.66-3.28 c7.34,0.17,13.44,5.69,14.34,12.97L114.28,121.98z M93.65,119.59h17.95c-1.12-5.64-6.11-9.67-11.86-9.56 c-1.91,0.08-3.69,0.96-4.92,2.42C93.49,114.56,93.06,117.14,93.65,119.59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2048",
    className: "st1",
    d: "M174.53,121.98h-22.49l0.17-1.35c0.9-7.29,7.01-12.82,14.36-12.98 c2.59,0.08,5.02,1.28,6.66,3.28c1.94,2.99,2.48,6.68,1.49,10.11L174.53,121.98z M154.73,119.59h17.94 c0.59-2.44,0.17-5.02-1.18-7.14c-1.23-1.46-3.02-2.33-4.93-2.42C160.83,109.94,155.85,113.96,154.73,119.59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_492",
    x: 112.67,
    y: 129.14,
    className: "st1",
    width: 40.66,
    height: 9.56
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2049",
    className: "st1",
    d: "M101.38,150.65c-5.28-0.73-9.15-5.32-8.99-10.65l2.25-0.21c0.41,4.83,3.3,8.47,6.74,8.47 s6.33-3.64,6.74-8.47l2.25,0.21C110.53,145.32,106.65,149.92,101.38,150.65"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2050",
    className: "st1",
    d: "M164.63,150.65c-5.26-0.74-9.13-5.33-8.96-10.65l2.25-0.21c0.41,4.83,3.3,8.47,6.74,8.47 s6.33-3.64,6.74-8.47l2.25,0.21c0.16,5.32-3.71,9.92-8.99,10.65"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstacionamiento);
export default __webpack_public_path__ + "static/media/estacionamiento.39974577e309c96526f3739d54a83929.svg";
export { ForwardRef as ReactComponent };